import { stripAuthHandoffFromUrl } from "./lib/authHandoff";

stripAuthHandoffFromUrl();
